import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-payment-block',
  templateUrl: './payment-block.component.html',
  styleUrl: '../../pages/subscription/subscription.component.css'
})
export class PaymentBlockComponent {
  @Input() title: string = '';
  @Input() image: string = '';
  @Input() currentPayment: string = '';
  @Input() value: any;
  @Output() setPayment = new EventEmitter<string>();

  onPaymentClick(): void {
    this.setPayment.emit(this.value);
  }
} 